import { CharacterCounter } from 'foundations-components/transitional/components/CharacterCounter';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MAX_APPROVAL_TITLE_LENGTH } from '../constants/requestModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalTitleTextInput = ({
  approvalTitle,
  approvalTitleError,
  autoFocus = false,
  onChangeApprovalTitle,
  onKeyDown,
  setApprovalTitleError,
  showLabel = true
}) => {
  const handleTextInputChange = ({
    target: {
      value
    }
  }) => {
    const remainingCount = MAX_APPROVAL_TITLE_LENGTH - value.length;
    if (remainingCount < 0 || !value.trim()) {
      setApprovalTitleError(true);
    } else {
      setApprovalTitleError(false);
    }
    onChangeApprovalTitle(value);
  };
  return /*#__PURE__*/_jsx(CharacterCounter, {
    counter: "down",
    defaultValue: approvalTitle,
    max: MAX_APPROVAL_TITLE_LENGTH,
    onChange: handleTextInputChange,
    renderInput: ({
      count,
      onChange,
      value
    }) => /*#__PURE__*/_jsx(FormControl, {
      characterCount: count,
      label: showLabel ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.approvalTitle.label"
      }) : undefined,
      help: showLabel ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.approvalTitle.help"
      }) : undefined,
      required: true,
      validationMessage: count < 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.approvalTitle.error.exceedsMaxLength",
        options: {
          maxLength: MAX_APPROVAL_TITLE_LENGTH
        }
      }) : !value.trim() ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.approvalTitle.error.noApprovalTitle"
      }) : undefined,
      error: approvalTitleError,
      children: /*#__PURE__*/_jsx(TextInput, {
        autoFocus: autoFocus,
        type: "text",
        value: value,
        onChange: onChange,
        onKeyDown: onKeyDown
      })
    })
  });
};